import { render, staticRenderFns } from "./DescriptionTrainingComponent.vue?vue&type=template&id=353e1996&scoped=true"
import script from "./DescriptionTrainingComponent.vue?vue&type=script&lang=js"
export * from "./DescriptionTrainingComponent.vue?vue&type=script&lang=js"
import style0 from "./DescriptionTrainingComponent.vue?vue&type=style&index=0&id=353e1996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353e1996",
  null
  
)

export default component.exports